import React, { useState, useEffect } from 'react';
import { 
  Row, Col, Card, CardHeader, CardTitle, CardBody, Table,
  TabContent, TabPane,
  Button, Badge, Input, 
  ButtonGroup
} from 'reactstrap';
// import classnames from 'classnames';
import { Line } from 'react-chartjs-2';
import numberWithCommas from "../constant/numberFormat.js";
import TinyLoading from "components/tiny/TinyLoading";

const WeeklyTotalPay = (props) => {
  const [state, setState] = useState({
    activeTab: '0',
    selectedUnions: {},
    selectedClubs: {},
    loading: true,
    chartType: 'union',
    highlightedItems: [],
    timeRange: 'all', // new state for time range filter: 'all', 'month', 'quarter', 'year'
    comparisonMode: false, // new state for comparison mode
    viewMode: 'table', // new state for view mode: 'chart' or 'table'
    paymentType: 'all', // new state for payment type: 'all', 'prepaid', 'credit'
    unionSortBy: 'default', // 排序方式: 'default' (按编号), 'amountDesc' (金额由高到低), 'amountAsc' (金额由低到高)
    clubSortBy: 'default', // Club的排序方式，独立于union
  });

  // useEffect(() => {
  //   props.onLoad();
  // }, []);

  useEffect(() => {
    // Add custom CSS for the scrollable tables
    const style = document.createElement('style');
    style.id = 'custom-table-scroll-style';
    style.innerHTML = `
      /* Custom scrollbar styling for Webkit browsers (Chrome, Safari, newer Edge) */
      .club-table::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      
      .club-table::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 4px;
      }
      
      .club-table::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.3);
        border-radius: 4px;
      }
      
      .club-table::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.5);
      }
      
      /* Firefox scrollbar styling */
      .club-table {
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.1);
      }
      
      /* Ensure the table container captures mouse events */
      .table-responsive {
        will-change: transform; /* Optimize for performance */
        touch-action: pan-y; /* Allow only vertical touch actions */
      }
      
      /* Fix for mobile iOS momentum scrolling */
      .table-responsive {
        -webkit-overflow-scrolling: touch;
      }
      
      /* Focus styles for keyboard accessibility */
      .table-responsive:focus {
        outline: none;
        box-shadow: inset 0 0 0 2px rgba(0, 123, 255, 0.5);
      }
      
      /* Sticky header and footer enhancements */
      thead th {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #343a40;
      }
      
      tfoot td {
        position: sticky;
        bottom: 0;
        z-index: 2;
        background-color: #343a40;
      }
      
      /* Add a subtle indicator when the table is scrollable */
      .club-table::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(to top, rgba(0,0,0,0.2), transparent);
        opacity: 0.7;
        pointer-events: none;
      }

      /* Toggle switch styling */
      .custom-toggle-switch {
        position: relative;
        display: inline-block;
        width: 140px;
        height: 34px;
      }
      
      .custom-toggle-switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      
      .toggle-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #343a40;
        transition: .4s;
        border-radius: 34px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }
      
      .toggle-slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 3px;
        background-color: white;
        transition: .4s;
        border-radius: 50%;
      }

      input:checked + .toggle-slider {
        background-color: #007bff;
      }

      input:checked + .toggle-slider:before {
        transform: translateX(80px);
      }
      
      .toggle-label {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        font-weight: 500;
        font-size: 12px;
        transition: opacity 0.3s ease;
      }

      .toggle-label.left {
        left: 10px;
        color: white;
        opacity: 0;
      }

      .toggle-label.right {
        right: 10px;
        color: white;
        opacity: 1;
      }
      
      input:checked + .toggle-slider .toggle-label.left {
        opacity: 1;
      }

      input:checked + .toggle-slider .toggle-label.right {
        opacity: 0;
      }

      
      .custom-toggle-switch {
        position: relative;
        display: inline-block;
        width: 110px;
        height: 30px;
      }

      .custom-toggle-switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      .toggle-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #343a40;
        transition: .4s;
        border-radius: 34px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .toggle-slider:before {
        position: absolute;
        content: "";
        height: 22px;
        width: 22px;
        left: 4px;
        bottom: 3px;
        background-color: white;
        transition: .4s;
        border-radius: 50%;
      }

      .header-controls {
        display: flex;
        align-items: center;
      }

      .header-controls .btn-group .btn {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
      }
    `;
    
    document.head.appendChild(style);
    
    // Cleanup function to remove the style element when component unmounts
    return () => {
      const existingStyle = document.getElementById('custom-table-scroll-style');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);

  useEffect(() => {
    // If data is loaded or changed
    if (props.weekly_total_pay && props.weekly_total_pay.length > 0) {
      const initialWeekData = props.weekly_total_pay[0];
      
      const selectedUnions = {};
      initialWeekData.unions.forEach(union => {
        selectedUnions[union.unionId] = true;
      });
      
      const selectedClubs = {};
      initialWeekData.clubs.forEach(club => {
        selectedClubs[club.clubId] = true;
      });
      
      setState(prevState => ({ 
        ...prevState,
        loading: false,
        selectedUnions,
        selectedClubs
      }));
    }
    
    // Handle error state changes
    if (props.error) {
      setState(prevState => ({ ...prevState, loading: false }));
    }
  }, [props.weekly_total_pay, props.error]);

  const toggle = (tab) => {
    if (state.activeTab !== tab) {
      setState(prevState => ({ ...prevState, activeTab: tab }));
    }
  };

  const toggleUnionSelection = (unionId) => {
    setState(prevState => ({
      ...prevState,
      selectedUnions: {
        ...prevState.selectedUnions,
        [unionId]: !prevState.selectedUnions[unionId]
      }
    }));
  };

  const toggleClubSelection = (clubId) => {
    setState(prevState => ({
      ...prevState,
      selectedClubs: {
        ...prevState.selectedClubs,
        [clubId]: !prevState.selectedClubs[clubId]
      }
    }));
  };

  const toggleChartType = (type) => {
    setState(prevState => ({
      ...prevState,
      chartType: type
    }));
  };

  const setTimeRange = (range) => {
    setState(prevState => ({
      ...prevState,
      timeRange: range
    }));
  };

  // Toggle view mode between chart and table
  const toggleViewMode = () => {
    setState(prevState => ({
      ...prevState,
      viewMode: prevState.viewMode === 'chart' ? 'table' : 'chart'
    }));
  };

  // Set payment type filter
  const setPaymentType = (type) => {
    setState(prevState => ({
      ...prevState,
      paymentType: type
    }));
  };

  const filterByPaymentType = (entities, entityType) => {
    if (state.paymentType === 'all') return entities;
    
    if (!union_info || union_info.length === 0) return entities;
    
    if (entityType === 'union') {
      // For unions, directly check if their valueStore matches the payment type
      return entities.filter(entity => {
        const unionInfo = union_info.find(info => info.unionID === entity.unionId);
        if (!unionInfo) return true; // Keep unions without info
        
        // 'prepaid' = true, 'credit' = false for valueStore
        return (state.paymentType === 'prepaid' && unionInfo.valueStore) || 
               (state.paymentType === 'credit' && !unionInfo.valueStore);
      });
    } else if (entityType === 'club') {
      // For clubs, first find which union they belong to
      return entities.filter(club => {
        // Special case: Clubs in union 9527
        const union9527 = union_info.find(info => info.unionID === '9527');
        
        if (!union9527) return true; // If we can't find union 9527, keep all clubs
        
        // Check if this club exists in union 9527's clubs
        const clubInfo = union9527.clubs[club.clubId];
        if (!clubInfo) return true; // Keep clubs without info
        
        // Filter based on club's valueStore property
        return (state.paymentType === 'prepaid' && clubInfo.valueStore) || 
               (state.paymentType === 'credit' && !clubInfo.valueStore);
      });
    }
    
    return entities; // Default fallback
  };

  const renderViewModeToggle = () => {
    return (
      <div className="view-mode-buttons">
        <ButtonGroup size="sm">
          <Button 
            color={state.viewMode === 'table' ? 'success' : 'secondary'}
            onClick={() => setState(prevState => ({ ...prevState, viewMode: 'table' }))}
            className="px-3"
          >
            <i className="fa fa-table mr-1"></i>
            Table
          </Button>
          <Button 
            color={state.viewMode === 'chart' ? 'success' : 'secondary'}
            onClick={() => setState(prevState => ({ ...prevState, viewMode: 'chart' }))}
            className="px-3"
          >
            <i className="fa fa-line-chart mr-1"></i>
            Chart
          </Button>
          
        </ButtonGroup>
      </div>
    );
  };


  const highlightItem = (itemId) => {
    setState(prevState => {
      const highlightedItems = [...prevState.highlightedItems];
      const index = highlightedItems.indexOf(itemId);
      
      if (index === -1) {
        highlightedItems.push(itemId);
      } else {
        highlightedItems.splice(index, 1);
      }
      
      return { ...prevState, highlightedItems };
    });
  };

  const formatDate = (dateRange) => {
    if (!dateRange) return '';
    
    const [start, end] = dateRange.split('-');
    
    const formatDate = (dateStr) => {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}/${month}/${day}`;
    };
    
    return `${formatDate(start)} - ${formatDate(end)}`;
  };

  const filterDataByTimeRange = (data) => {
    if (state.timeRange === 'all') return data;
    
    const now = new Date();
    let cutoffDate;
    
    switch(state.timeRange) {
      case 'month':
        cutoffDate = new Date(now.setMonth(now.getMonth() - 1));
        break;
      case 'quarter':
        cutoffDate = new Date(now.setMonth(now.getMonth() - 3));
        break;
      case 'year':
        cutoffDate = new Date(now.setFullYear(now.getFullYear() - 1));
        break;
      default:
        return data;
    }
    
    return data.filter(week => {
      const periodEnd = week.period.split('-')[1];
      const year = periodEnd.substring(0, 4);
      const month = periodEnd.substring(4, 6) - 1; // JS months are 0-indexed
      const day = periodEnd.substring(6, 8);
      const periodDate = new Date(year, month, day);
      return periodDate >= cutoffDate;
    });
  };

  const prepareChartData = () => {
    const { weekly_total_pay } = props;
    const { selectedUnions, selectedClubs, chartType, comparisonMode } = state;
    
    if (!weekly_total_pay || weekly_total_pay.length === 0) {
      return {
        labels: [],
        datasets: []
      };
    }

    // Apply time range filter
    const filteredData = filterDataByTimeRange([...weekly_total_pay]);
    
    // Reverse order to show oldest to newest
    const periods = [...filteredData].reverse().map(week => formatDate(week.period));
    
    let datasets = [];
    
    if (chartType === 'union') {
      // Create a unique list of all union IDs across all weeks
      const allUnionIds = new Set();
      filteredData.forEach(week => {
        week.unions.forEach(union => {
          allUnionIds.add(union.unionId);
        });
      });
      
      // For each union, create a dataset
      allUnionIds.forEach(unionId => {
        // Check if this union should be included based on payment type
        if (state.paymentType !== 'all') {
          const unionInfo = union_info.find(info => info.unionID === unionId);
          if (unionInfo) {
            const isValueStore = unionInfo.valueStore;
            if ((state.paymentType === 'prepaid' && !isValueStore) || 
                (state.paymentType === 'credit' && isValueStore)) {
              return; // Skip this union if it doesn't match the payment type
            }
          }
        }
        
        if (selectedUnions[unionId]) {
          // Rest of the union dataset creation code remains the same...
          
          // Find union name from the first week it appears
          let unionName = '';
          for (const week of filteredData) {
            const union = week.unions.find(u => u.unionId === unionId);
            if (union) {
              unionName = union.unionName;
              break;
            }
          }
          
          const dataPoints = [...filteredData].reverse().map(week => {
            const union = week.unions.find(u => u.unionId === unionId);
            return union ? union.totalPay : null;
          });
          
          // For comparison mode, calculate growth rates
          let growthData = null;
          if (comparisonMode && dataPoints.length > 1) {
            growthData = dataPoints.map((value, index) => {
              if (index === 0 || !value || !dataPoints[index - 1]) return null;
              const prevValue = dataPoints[index - 1];
              return prevValue !== 0 ? ((value - prevValue) / Math.abs(prevValue)) * 100 : null;
            });
          }
          
          datasets.push({
            label: `${unionId} ${unionName}`,
            data: comparisonMode ? growthData : dataPoints,
            borderColor: getColor(unionId),
            backgroundColor: getColor(unionId, 0.2),
            borderWidth: state.highlightedItems.includes(unionId) ? 4 : 2,
            fill: false,
            tension: 0.4
          });
        }
      });
    } else { // club chart
      // Create a unique list of all club IDs across all weeks
      const allClubIds = new Set();
      filteredData.forEach(week => {
        week.clubs.forEach(club => {
          allClubIds.add(club.clubId);
        });
      });
      
      // For each club, create a dataset
      allClubIds.forEach(clubId => {
        // Check if this club should be included based on payment type
        if (state.paymentType !== 'all') {
          const union9527 = union_info.find(info => info.unionID === '9527');
          if (union9527 && union9527.clubs[clubId]) {
            const isValueStore = union9527.clubs[clubId].valueStore;
            if ((state.paymentType === 'prepaid' && !isValueStore) || 
                (state.paymentType === 'credit' && isValueStore)) {
              return; // Skip this club if it doesn't match the payment type
            }
          }
        }
        
        if (selectedClubs[clubId]) {
          // Rest of the club dataset creation code remains the same...
          
          // Find club name from the first week it appears
          let clubName = '';
          for (const week of filteredData) {
            const club = week.clubs.find(c => c.clubId === clubId);
            if (club) {
              clubName = club.clubName;
              break;
            }
          }
          
          const dataPoints = [...filteredData].reverse().map(week => {
            const club = week.clubs.find(c => c.clubId === clubId);
            return club ? club.totalPay : null;
          });
          
          // For comparison mode, calculate growth rates
          let growthData = null;
          if (comparisonMode && dataPoints.length > 1) {
            growthData = dataPoints.map((value, index) => {
              if (index === 0 || !value || !dataPoints[index - 1]) return null;
              const prevValue = dataPoints[index - 1];
              return prevValue !== 0 ? ((value - prevValue) / Math.abs(prevValue)) * 100 : null;
            });
          }
          
          datasets.push({
            label: `${clubId} ${clubName}`,
            data: comparisonMode ? growthData : dataPoints,
            borderColor: getColor(clubId),
            backgroundColor: getColor(clubId, 0.2),
            borderWidth: state.highlightedItems.includes(clubId) ? 4 : 2,
            fill: false,
            tension: 0.4
          });
        }
      });
    }

    datasets = enhanceDatasets(datasets);
    
    return {
      labels: periods,
      datasets
    };
  };


  // Function to enhance dataset creation with more distinct visual properties
  const enhanceDatasets = (datasets) => {
    return datasets.map(dataset => {
      // Extract ID from the label (assuming format is "ID Name")
      const id = dataset.label.split(' ')[0];
      
      // Return enhanced dataset
      return {
        ...dataset,
        borderWidth: state.highlightedItems.includes(id) ? 4 : 3,
        pointStyle: state.highlightedItems.includes(id) ? 'star' : 'circle',
        pointRadius: state.highlightedItems.includes(id) ? 5 : 2,
        pointHoverRadius: 8,
        pointBackgroundColor: getColor(id),
        pointBorderColor: '#fff',
        pointBorderWidth: 1,
        tension: 0.3, // Less curvy lines for better visibility
        fill: false,  // No fill to avoid overlapping colors
        
        // Create dashed or dotted lines for some datasets to increase distinction
        borderDash: parseInt(id) % 5 === 0 ? [5, 5] : [], // Every 5th ID gets dashed lines
      };
    });
  };


  // Updated getColor function with more distinct colors
  const getColor = (id, alpha = 1) => {
    // Create a palette with highly distinguishable colors
    // These colors are carefully selected to be visually distinct from each other
    const colors = [
      '#FF3B30', // Bright Red
      '#4CD964', // Bright Green
      '#007AFF', // Bright Blue
      '#FFCC00', // Bright Yellow
      '#FF9500', // Orange
      '#5856D6', // Purple
      '#FF2D55', // Pink
      '#00FFFF', // Cyan
      '#8E44AD', // Dark Purple
      '#2ECC71', // Emerald Green
      '#E74C3C', // Dark Red
      '#3498DB', // Light Blue
      '#F1C40F', // Gold
      '#1ABC9C', // Turquoise
      '#34495E', // Dark Blue-Gray
      '#E67E22', // Dark Orange
      '#A569BD', // Light Purple
      '#27AE60', // Dark Green
      '#D35400', // Burnt Orange
      '#16A085', // Green Sea
      '#95A5A6', // Light Gray
      '#9B59B6', // Amethyst
      '#FB6D51', // Coral
      '#00E5FF', // Light Cyan
      '#C0392B', // Crimson
      '#F39C12', // Amber
      '#6C3483', // Deep Purple
      '#2980B9', // Steel Blue
      '#229954', // Forest Green
      '#E74C3C', // Tomato Red
      '#8BC34A', // Light Green
      '#FFC0CB', // Light Pink
      '#607D8B', // Blue Gray
      '#795548', // Brown
      '#9C27B0', // Deep Purple
      '#CDDC39'  // Lime
    ];
    
    // Ensure specific entities always get the same color for consistency
    const specificColorMap = {
      '142': '#32CD32',    // Green - 142 Winner Takes All
      '150': '#FF00FF',    // Magenta - 150 Boss
      '222': '#FF1493',    // Pink - 222 FreeStyle
      '5566': '#FF4500',   // OrangeRed - 5566 大霸
      '608': '#9370DB',    // MediumPurple - 608 世界海洋日
      '852': '#FFD700'     // Gold - 852 Coolest Union
    };
    
    // Check if we have a specific color assigned for this ID
    if (specificColorMap[id]) {
      const baseColor = specificColorMap[id];
      
      // If alpha is 1, return the hex color directly
      if (alpha === 1) {
        return baseColor;
      }
      
      // If alpha is less than 1, convert hex to rgba
      const r = parseInt(baseColor.slice(1, 3), 16);
      const g = parseInt(baseColor.slice(3, 5), 16);
      const b = parseInt(baseColor.slice(5, 7), 16);
      
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    
    // For other IDs, use the hash method with our distinct color palette
    const hash = id.toString().split('').reduce((acc, char) => {
      return acc + char.charCodeAt(0);
    }, 0);
    
    // Get the base hex color
    const baseColor = colors[hash % colors.length];
    
    // If alpha is 1, return the hex color directly
    if (alpha === 1) {
      return baseColor;
    }
    
    // If alpha is less than 1, convert hex to rgba
    const r = parseInt(baseColor.slice(1, 3), 16);
    const g = parseInt(baseColor.slice(3, 5), 16);
    const b = parseInt(baseColor.slice(5, 7), 16);
    
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  
  const renderTimeRangeFilter = () => {
    return (
      <div className="btn-group btn-group-sm">
        <Button 
          color={state.timeRange === 'all' ? 'danger' : 'secondary'} 
          onClick={() => setTimeRange('all')}
          size="sm"
        >
          All Time
        </Button>
        <Button 
          color={state.timeRange === 'year' ? 'danger' : 'secondary'} 
          onClick={() => setTimeRange('year')}
          size="sm"
        >
          Last Year
        </Button>
        <Button 
          color={state.timeRange === 'quarter' ? 'danger' : 'secondary'} 
          onClick={() => setTimeRange('quarter')}
          size="sm"
        >
          Last Quarter
        </Button>
        <Button 
          color={state.timeRange === 'month' ? 'danger' : 'secondary'} 
          onClick={() => setTimeRange('month')}
          size="sm"
        >
          Last Month
        </Button>
      </div>
    );
  };


  // Add this function to your WeeklyTotalPay component

  const preventParentScroll = () => {
    // This function will be called after component mounts and after any tab change
    setTimeout(() => {
      // Find all table containers that should have isolated scrolling
      const tableContainers = document.querySelectorAll('.table-responsive');
      
      tableContainers.forEach(container => {
        // Remove previous event listeners to avoid duplicates
        container.removeEventListener('wheel', handleWheel);
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
        
        // Add new event listeners
        container.addEventListener('wheel', handleWheel, { passive: false });
        container.addEventListener('touchstart', handleTouchStart, { passive: false });
        container.addEventListener('touchmove', handleTouchMove, { passive: false });
        
        // Add a class to indicate the container is scroll-isolated
        container.classList.add('scroll-isolated');
      });
      
      // Add a global style for scroll-isolated elements if it doesn't exist
      if (!document.getElementById('scroll-isolation-style')) {
        const style = document.createElement('style');
        style.id = 'scroll-isolation-style';
        style.innerHTML = `
          .scroll-isolated {
            overscroll-behavior: contain;
            -webkit-overflow-scrolling: touch;
            scroll-behavior: smooth;
            isolation: isolate;
          }
          
          .scroll-isolated:focus {
            outline: none;
          }
        `;
        document.head.appendChild(style);
      }
    }, 100); // Small delay to ensure DOM is ready
  };

  // Wheel event handler with improved algorithm
  function handleWheel(event) {
    const container = event.currentTarget;
    const { deltaY } = event;
    const { scrollTop, scrollHeight, clientHeight } = container;
    
    // Calculate if we should allow parent scrolling
    const scrollingUp = deltaY < 0;
    const scrollingDown = deltaY > 0;
    const atTop = Math.abs(scrollTop) < 1; // Near top (accounts for precision errors)
    const atBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 1; // Near bottom
    
    // Allow parent scrolling only at boundaries
    if ((scrollingUp && atTop) || (scrollingDown && atBottom)) {
      return; // Let the event propagate to parent
    }
    
    // Otherwise prevent default and handle scrolling ourselves
    event.preventDefault();
    event.stopPropagation();
    
    // Smoother scrolling with requestAnimationFrame
    requestAnimationFrame(() => {
      container.scrollTop += deltaY;
    });
  }

// Touch handling for mobile devices
  let touchStartY = 0;
  let touchStartScrollTop = 0;

  function handleTouchStart(event) {
    const touch = event.touches[0];
    touchStartY = touch.clientY;
    touchStartScrollTop = event.currentTarget.scrollTop;
    
    // If the container can scroll, prevent parent scrolling
    const container = event.currentTarget;
    if (container.scrollHeight > container.clientHeight) {
      event.stopPropagation();
    }
  }

  function handleTouchMove(event) {
    const container = event.currentTarget;
    const touch = event.touches[0];
    const deltaY = touchStartY - touch.clientY;
    
    const { scrollTop, scrollHeight, clientHeight } = container;
    const scrollingUp = deltaY < 0;
    const scrollingDown = deltaY > 0;
    const atTop = scrollTop <= 0;
    const atBottom = scrollTop + clientHeight >= scrollHeight;
    
    // Allow parent scrolling only at boundaries
    if ((scrollingUp && atTop) || (scrollingDown && atBottom)) {
      return; // Let the event propagate to parent
    }
    
    // Otherwise prevent default and handle scrolling ourselves
    event.preventDefault();
    event.stopPropagation();
    
    // Apply scrolling with touch movement
    container.scrollTop = touchStartScrollTop + deltaY;
  }

  // Add this to the component
  useEffect(() => {
    props.onLoad();
    preventParentScroll();
    
    // Re-apply scroll handling when tab changes
    return () => {
      const tableContainers = document.querySelectorAll('.table-responsive');
      tableContainers.forEach(container => {
        container.removeEventListener('wheel', handleWheel);
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
      });
    };
  }, []);

  // Also add this to re-apply scroll isolation when tab changes
  useEffect(() => {
    preventParentScroll();
  }, [state.activeTab]);

  // 设置排序方式 - 根据表格类型设置不同的状态
  const setSortBy = (sortOption, tableType) => {
    setState(prevState => ({
      ...prevState,
      [tableType === 'union' ? 'unionSortBy' : 'clubSortBy']: sortOption
    }));
  };

  // 根据排序选项对数据进行排序
  const sortEntities = (entities, sortBy) => {
    if (sortBy === 'default') return entities; // 保持原始顺序
    
    return [...entities].sort((a, b) => {
      if (sortBy === 'amountDesc') return b.totalPay - a.totalPay;
      if (sortBy === 'amountAsc') return a.totalPay - b.totalPay;
      return 0;
    });
  };

  const renderEntityTable = (entities, type, selections, toggleSelection) => {
    const filteredEntities = filterByPaymentType(entities, type);
    // 应用排序 - 根据表格类型使用对应的排序状态
    const sortBy = type === 'union' ? state.unionSortBy : state.clubSortBy;
    const sortedEntities = sortEntities(filteredEntities, sortBy);
    const entityType = type === 'union' ? 'Union' : 'Club';
    const bgColor = type === 'union' ? 'bg-primary' : 'bg-primary';
    
    // Set different max heights for unions and clubs
    const tableMaxHeight = '750px';
    
    // Determine if this is a club table
    const isClubTable = type === 'club';
    
    // Create a unique ID for this table
    const tableId = `${type}-table-container`;
    
    // Get payment type label for display
    let paymentTypeLabel = '';
    if (state.paymentType === 'prepaid') {
      paymentTypeLabel = '儲值制';
    } else if (state.paymentType === 'credit') {
      paymentTypeLabel = '信用制';
    }

    return (
      <Card className="shadow-sm">
        <CardHeader className={`${bgColor} text-white`}>
          <CardTitle style={{fontWeight:"bold"}} tag="h5">
            {isClubTable ? 'Clubs in Union 9527 (Except Club 9527)' : 'Unions (Except 9527)'} 
            <Badge color="light" className="ml-2 text-dark">
              Total: {filteredEntities.length}
            </Badge>
            {state.paymentType !== 'all' && (
              <Badge color="warning" className="ml-2">
                {paymentTypeLabel}
              </Badge>
            )}
            {/* 为表格添加排序下拉菜单 - 分别使用不同的状态和事件处理函数 */}
            <div className="float-right" style={{ marginTop: "-10px" }}>
              <Input 
                type="select" 
                className="form-control text-white border-secondary"
                value={type === 'union' ? state.unionSortBy : state.clubSortBy}
                onChange={(e) => setSortBy(e.target.value, type)}
                style={{
                  height: '34px',
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                  cursor: 'pointer',
                  fontWeight: '500',
                  background: 'linear-gradient(45deg, #8e44ad, #3498db)',
                  border: '1px solid #9b59b6',
                  width: '130px'
                }}
              >
                <option value="default" style={{ backgroundColor: '#673ab7', color: 'white' }}>
                  按編號排列
                </option>
                <option value="amountDesc" style={{ backgroundColor: '#673ab7', color: 'white' }}>
                  金額由高到低
                </option>
                <option value="amountAsc" style={{ backgroundColor: '#673ab7', color: 'white' }}>
                  金額由低到高
                </option>
              </Input>
            </div>
          </CardTitle>
        </CardHeader>
        <CardBody className="p-0">
          {/* Table container with enhanced scrolling behavior */}
          <div 
            id={tableId}
            className={`table-responsive ${isClubTable ? 'club-table' : 'union-table'}`}
            style={{ 
              maxHeight: tableMaxHeight,
              overflow: 'auto',
              position: 'relative',
              ...(isClubTable && {
                minHeight: '500px',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 5px rgba(0,0,0,0.2)',
                padding: '0',
                margin: '0',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.3) rgba(0,0,0,0.2)',
              })
            }}
            data-table-type={type}
            data-scroll-container="true"
            tabIndex="0"
          >
            <Table hover className="mb-0" size="sm">
              <thead className="bg-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <tr>
                  <th className="text-center align-middle" style={{ width: '40px' }}>
                    <i className="fa fa-eye"></i>
                  </th>
                  <th style={{ width: '50px' }}>#</th>
                  <th>{entityType} ID</th>
                  <th>{entityType} Name</th>
                  <th className="text-right">B端得到</th>
                  <th></th>
                  {/* <th className="text-center" style={{ width: '80px' }}>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {sortedEntities.length > 0 ? (
                  sortedEntities.map((entity, index) => {
                    const id = type === 'union' ? entity.unionId : entity.clubId;
                    const name = type === 'union' ? entity.unionName : entity.clubName;
                    
                    // Check if this entity has payment type info available
                    let paymentTypeInfo = '';
                    if (type === 'union') {
                      const unionInfo = union_info && union_info.find(info => info.unionID === id);
                      if (unionInfo) {
                        paymentTypeInfo = unionInfo.valueStore ? '儲值制' : '信用制';
                      }
                    } else if (type === 'club') {
                      const union9527 = union_info && union_info.find(info => info.unionID === '9527');
                      if (union9527 && union9527.clubs && union9527.clubs[id]) {
                        paymentTypeInfo = union9527.clubs[id].valueStore ? '儲值制' : '信用制';
                      }
                    }
                    
                    return (
                      <tr key={id} className={state.highlightedItems.includes(id) ? 'table-info' : ''}>
                        <td className="text-center">
                          <div 
                            className="modern-checkbox"
                            onClick={() => toggleSelection(id)}
                            style={{
                              display: 'inline-block',
                              position: 'relative',
                              width: '38px',
                              height: '20px',
                              margin: '0 auto',
                              cursor: 'pointer'
                            }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                right: '0',
                                bottom: '0',
                                backgroundColor: selections[id] ? '#8e44ad' : '#2c3e50',
                                borderRadius: '20px',
                                transition: 'all 0.3s ease',
                                border: '1px solid rgba(255,255,255,0.2)'
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                height: '16px',
                                width: '16px',
                                left: selections[id] ? '19px' : '3px',
                                bottom: '2px',
                                backgroundColor: '#ffffff',
                                borderRadius: '50%',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                              }}
                            />
                          </div>
                        </td>
                        <td className="text-center font-weight-bold">{index + 1}</td>
                        <td>{id}</td>
                        <td>
                          {name}
                          {paymentTypeInfo && (
                            <Badge 
                              color={paymentTypeInfo === '儲值制' ? 'success' : 'info'} 
                              className="ml-2" 
                              pill
                              size="sm"
                            >
                              {paymentTypeInfo}
                            </Badge>
                          )}
                        </td>
                        <td className="text-right">
                          <span className={entity.totalPay >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'}>
                            {entity.totalPay >= 0 ? '+' : ''}{numberWithCommas(entity.totalPay.toFixed(2))}
                          </span>
                        </td>
                        {/* <td className="text-center">
                          <Button 
                            color={state.highlightedItems.includes(id) ? 'warning' : 'primary'} 
                            size="sm" 
                            className="btn-icon"
                            onClick={() => highlightItem(id)}
                          >
                            <i className={state.highlightedItems.includes(id) ? 'fa fa-star' : 'fa fa-line-chart'}></i>
                          </Button>
                        </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-3">
                      <i className="fa fa-info-circle mr-2"></i>
                      No {entityType.toLowerCase()}s found for the selected payment type.
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot className="bg-dark text-white" style={{ position: 'sticky', bottom: 0, zIndex: 1 }}>
                <tr>
                  <td colSpan="4" className="text-right"><strong>Total:</strong></td>
                  <td className="text-right">
                    <strong>
                      {numberWithCommas(
                        sortedEntities
                          .reduce((sum, entity) => sum + (entity.totalPay || 0), 0)
                          .toFixed(2)
                      )}
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </Table>
            
            {/* Custom scrollbar indicators */}
            {isClubTable && sortedEntities.length > 10 && (
              <div className="scroll-indicator-container" style={{ 
                position: 'absolute', 
                right: '0', 
                top: '50%', 
                transform: 'translateY(-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '5px',
                zIndex: 2
              }}>
                <div className="scroll-up-indicator" style={{ 
                  fontSize: '12px', 
                  color: 'rgba(255,255,255,0.5)',
                  marginBottom: '5px'
                }}>
                  <i className="fa fa-chevron-up"></i>
                </div>
                <div className="scroll-down-indicator" style={{ 
                  fontSize: '12px', 
                  color: 'rgba(255,255,255,0.5)'
                }}>
                  <i className="fa fa-chevron-down"></i>
                </div>
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    );
  };

  const navigateWeeks = (direction) => {
    const currentTab = parseInt(state.activeTab);
    const newTab = currentTab + direction;
    
    if (newTab >= 0 && newTab < props.weekly_total_pay.length) {
      toggle(newTab.toString());
    }
  };

  const renderTabContent = () => {
    const { weekly_total_pay } = props;
    
    if (!weekly_total_pay || weekly_total_pay.length === 0) return null;
    
    return (
      <TabContent activeTab={state.activeTab}>
        {weekly_total_pay.map((weekData, index) => (
          <TabPane key={index} tabId={index.toString()}>
            <Row>
              <Col lg="6" className="mb-4">
                {renderEntityTable(
                  weekData.unions, 
                  'union', 
                  state.selectedUnions, 
                  toggleUnionSelection
                )}
              </Col>
              <Col lg="6" className="mb-4">
                {renderEntityTable(
                  weekData.clubs, 
                  'club', 
                  state.selectedClubs, 
                  toggleClubSelection
                )}
              </Col>
            </Row>
          </TabPane>
        ))}
      </TabContent>
    );
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: false,
        grid: {
          drawBorder: false,
          color: 'rgba(200, 200, 200, 0.1)'
        },
        ticks: {
          callback: function(value) {
            if (state.comparisonMode) {
              return value.toFixed(1) + '%';
            }
            return numberWithCommas(value);
          },
          color: 'rgba(200, 200, 200, 0.8)'
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: 'rgba(200, 200, 200, 0.8)',
          maxRotation: 45,
          minRotation: 45
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          usePointStyle: true,
          color: 'rgba(200, 200, 200, 0.8)'
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              if (state.comparisonMode) {
                label += context.parsed.y.toFixed(2) + '%';
              } else {
                label += numberWithCommas(context.parsed.y.toFixed(2));
              }
            }
            return label;
          }
        }
      }
    }
  };

  const { loading, viewMode } = state;
  const { weekly_total_pay, error, union_info } = props;

  // Render chart view
  const renderChartView = () => {
    return (
      <>
        <div className="chart-container mb-4" style={{ height: '500px', position: 'relative' }}>
          <Line 
            data={prepareChartData()} 
            options={chartOptions}
          />
        </div>
        
        {/* <div className="chart-info mb-4">
          <div className="alert alert-info d-flex align-items-center">
            <div className="alert-icon mr-3">
              <i className="fa fa-info-circle fa-2x"></i>
            </div>
            <div>
              <h6 className="alert-heading mb-1">Chart Interactions</h6>
              <p className="mb-0">
                Click on legends to toggle visibility. Use the chart buttons to highlight specific items.
              </p>
            </div>
          </div>
        </div> */}
      </>
    );
  };

  // Render table view
  const renderTableView = () => {
    return (
      <div className="table-view-container">
        {renderTabContent()}
      </div>
    );
  };

  const renderPaymentTypeFilter = () => {
    return (
      <ButtonGroup>
        <Button 
          color={state.paymentType === 'all' ? 'info' : 'secondary'} 
          onClick={() => setPaymentType('all')}
          className="px-3"
        >
          所有
        </Button>
        <Button 
          color={state.paymentType === 'prepaid' ? 'info' : 'secondary'} 
          onClick={() => setPaymentType('prepaid')}
          className="px-3"
        >
          儲值制
        </Button>
        <Button 
          color={state.paymentType === 'credit' ? 'info' : 'secondary'} 
          onClick={() => setPaymentType('credit')}
          className="px-3"
        >
          信用制
        </Button>
      </ButtonGroup>
    );
  };

  // Render week selector (only for table view)
  const renderWeekSelector = () => {
    const { weekly_total_pay } = props;
    
    if (!weekly_total_pay || weekly_total_pay.length === 0) return null;
    
    return (
      <div className="week-selector-container">
        <div className="week-picker-header mb-2">
          <h5 className="text-light mb-0">
            <i className="fa fa-calendar mr-2"></i>Select Week Period
          </h5>
        </div>
        
        <div className="week-picker-controls d-flex align-items-center" style={{width:"50%"}}>
          <div className="week-picker-select flex-grow-1 mr-3">
            <Input 
              type="select" 
              className="form-control text-white border-secondary custom-select"
              value={state.activeTab}
              onChange={(e) => toggle(e.target.value)}
              style={{
                height: '38px',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                cursor: 'pointer',
                fontWeight: '500',
                backgroundColor: '#505050'
              }}
            >
              {weekly_total_pay.map((weekData, index) => (
                <option 
                  key={index} 
                  value={index.toString()} 
                  style={{
                    backgroundColor: '#505050', 
                    color: 'white',
                    fontWeight: '500'
                  }}
                >
                  {formatDate(weekData.period)}
                </option>
              ))}
            </Input>
          </div>
          
          <div className="week-navigation-buttons">
            <Button 
              color="primary" 
              outline
              size="sm" 
              className="mr-2" 
              onClick={() => navigateWeeks(1)} 
              disabled={parseInt(state.activeTab) === weekly_total_pay.length - 1}
              style={{
                width: '100px',
                borderRadius: '20px',
                fontWeight: '500',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="fa fa-chevron-left mr-1"></i> Previous
            </Button>
            <Button 
              color="primary"
              outline
              size="sm" 
              onClick={() => navigateWeeks(-1)} 
              disabled={parseInt(state.activeTab) === 0}
              style={{
                width: '100px',
                borderRadius: '20px',
                fontWeight: '500',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              Next <i className="fa fa-chevron-right ml-1"></i>
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="content">
      <Card className="shadow-lg border-0 mb-4">
      
        <CardHeader className="bg-dark text-white border-0 d-flex justify-content-between align-items-center">
          <CardTitle tag="h4" className="m-0">
            <i className="fa fa-chart-line mr-2"></i>
            每周B端交付金額分析
          </CardTitle>
          <div className="header-controls d-flex align-items-center">
            {renderPaymentTypeFilter()} {/* Payment type filter in header */}
            <div className="ml-3">
              {renderViewModeToggle()} {/* View toggle in header */}
            </div>
          </div>
        </CardHeader>
        <CardBody className="bg-dark text-white p-0">
          {loading ? (
            <TinyLoading text="載入資料" variant="block" />
          ) : error ? (
            <div className="text-center py-5">
              <div className="error-icon mb-3">
                <i className="fa fa-exclamation-triangle fa-4x text-warning"></i>
              </div>
              <h4 className="text-danger">Error Loading Data</h4>
              <p>{error}</p>
              <Button color="primary" onClick={() => props.onLoad()}>
                <i className="fa fa-refresh mr-1"></i> Try Again
              </Button>
            </div>
          ) : weekly_total_pay && weekly_total_pay.length > 0 ? (
            <div className="p-4">
              {viewMode === 'table' && (
                <Row>
                  <Col lg="12" className="mb-4">
                    {renderWeekSelector()}
                  </Col>
                </Row>
              )}
              
              {viewMode === 'chart' && (
                <div className="chart-controls mb-4">
                  <Row>
                    <Col md="6">
                      <div className="d-flex justify-content-start">
                        <ButtonGroup size="sm">
                          <Button 
                            color={state.chartType === 'union' ? 'primary' : 'secondary'} 
                            onClick={() => toggleChartType('union')}
                          >
                            <i className="fa fa-building mr-1"></i>
                            Union Chart
                          </Button>
                          <Button 
                            color={state.chartType === 'club' ? 'primary' : 'secondary'} 
                            onClick={() => toggleChartType('club')}
                          >
                            <i className="fa fa-users mr-1"></i>
                            Club Chart
                          </Button>
                        </ButtonGroup>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="d-flex justify-content-end">
                        {renderTimeRangeFilter()}
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
              
              {viewMode === 'chart' ? renderChartView() : renderTableView()}
            </div>
          ) : (
            <div className="text-center py-5">
              <i className="fa fa-chart-area fa-4x text-muted mb-3"></i>
              <h4>No data available</h4>
              <p>There is no weekly total pay data available.</p>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default WeeklyTotalPay;